
import React, { useRef, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import Layout from '../components/Layout'
import PortableText from '@sanity/block-content-to-react'
import StudentList from '../components/StudentList'
import styled from 'styled-components'
import SiteHeader from '../components/SiteHeader'
import FacultyLetter from '../components/Letter'
import Credits from '../components/SiteCredits'
import Description from '../components/ProgramDescription'
import Footer from '../components/Footer'
import StudentGrid from '../components/StudentGrid'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const ProgramDescription = styled.div`
  padding: 0.5em;
  color: var(--light);
  position:relative;
  z-index:2;
  background: var(--black);
  padding-left:1em;
  /* margin-bottom:10em; */

  ${media.medium}{
    padding-left: var(--left-margin);

    /* padding:2em; */
  }
`

const SocialLinks = styled.ul`
  background: var(--black);
  margin: 0;
  list-style: none;
  font-size: var(--small-text);
  font-weight: 100;
  li {
    a {
      color: var(--white);
      text-decoration: none;
    }
  }
`

export default function HomePage ({ data: { homepage, students } }) {
  const data = homepage.nodes[0]

  return (
    <Layout students={students.nodes}t>
      <Helmet>
        <title>CCA MFA 2021</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <SiteHeader />
      <StudentGrid students={students.nodes} />
      <ProgramDescription>
        <FacultyLetter data={data} />
        <Credits data={data} />
        <Description data={data} />
      </ProgramDescription>

    </Layout>
  )
}

export const query = graphql`
  query {
    homepage: allSanityHomepage {
      nodes {
        _rawProgramDescription
        _rawLetter
        social_links {
          _key
          link_text
          url
        }
        _rawVisitingCurators
        _rawVisitingArtists
        _rawWorkshops
      }
    }

    students: allSanityPerson(sort: { fields: [last_name], order: ASC }) {
      nodes {
        id
        first_name
        last_name
        hero_image {
          asset {
            fixed(width: 200, height: 200) {
              ...GatsbySanityImageFixed
            }
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
        }
        slug {
          current
        }
      }
    }
  }
`
